import { Component, OnInit, AfterViewInit } from '@angular/core'
import { environment } from "../../../environments/environment"
import { Subscription } from 'rxjs'
import { AppService } from 'src/app/server/app.service'
import { StorageService } from 'src/app/shared/storage.service'
import { AuthService } from 'src/app/shared/security/auth.service';
export let isDebugMode = environment.isDebugMode

@Component({
  selector: 'flow-starter',
  templateUrl: './starter.component.html',
  styleUrls: ['./starter.component.scss'],
  host: { "(window:resize)": "onResize($event)" }
})
export class StarterComponent implements OnInit, AfterViewInit {

  subscriptions: Array<Subscription> = []
  styles: any
  rowHeight: number[]
  windowWidth: number = window.innerWidth
  windowHeight: number = window.innerHeight
  sideBarExpand: boolean = false
  themeid: number = 1

  constructor(
    private appService: AppService
  ) { }

  ngOnInit() {
    isDebugMode ? console.info('ngOnInit()') : undefined
    this.setStyles()
    this.subscriptions.push(
      this.appService.eventSideBarExpand.subscribe(toggle => {
        this.sideBarExpand = !this.sideBarExpand
      })

      , this.appService.eventSession.subscribe(data => {
        this.themeid = this.appService.session.themeid
      })

    )
  }

  ngAfterViewInit() {
    isDebugMode ? console.info('ngAfterViewInit()') : undefined
    this.setStyles()
  }

  ngOnDestroy() {
    isDebugMode ? console.info('ngOnDestroy()') : undefined
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe()
    })
  }

  setStyles() {
    isDebugMode ? console.info('setStyles()') : undefined

    this.rowHeight = [50, this.windowHeight - 75, 5]
    // if (this.windowWidth < 768) {
    //   this.rowHeight = [50, this.windowHeight - 75, 5]
    // }
    const styles = {
      "grid-template-rows": `${this.rowHeight[0]}px   ${this.rowHeight[1]}px   ${this.rowHeight[2]}px`
    }

    this.styles = styles
  }

  onResize(event) {
    //isDebugMode ? console.info('onResize()') : undefined
    this.windowWidth = event.target.innerWidth
    this.windowHeight = event.target.innerHeight
    this.setStyles()
  }

}
